import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import { AuthService } from './auth.service';
import { SocketService } from './shoket.service';

@Injectable({ providedIn: 'root' })
export class NotificacionesGlobalesService {
  private authService = inject(AuthService);
  private socket = inject(SocketService);
  private snackBar = inject(MatSnackBar);

  private usuarioSub?: Subscription;
  private eventosSub?: Subscription;

  private usuarioActual: any = null;

  iniciar(): void {
    // Evita registrar todo dos veces si se llama de nuevo.
    if (this.usuarioSub) return;

    this.usuarioSub = this.authService.usuario$.subscribe((usuario) => {
      this.usuarioActual = usuario;

      // Cierre de sesión: se cancelan los eventos.
      if (!usuario) {
        this.eventosSub?.unsubscribe();
        this.eventosSub = undefined;
        this.socket.disconnect();
        return;
      }

      const token = this.authService.getToken();
      if (!token) return;

      this.socket.connect(token);

      // Si cambia el usuario, se reinician las suscripciones.
      this.eventosSub?.unsubscribe();
      this.eventosSub = this.escucharEventos();
    });
  }

  private escucharEventos(): Subscription {
    const sub = new Subscription();

    sub.add(
      this.socket.on<any>('paciente.creado').subscribe((data) => {
        const paciente = data?.paciente ?? data;
        const nombre = this.nombreCompleto(paciente);

        this.mostrar(
          nombre ? `Nuevo paciente registrado: ${nombre}` : 'Se ha registrado un nuevo paciente.',
          ['notificacion-novamed'],
        );
      }),
    );

    sub.add(
      this.socket.on<any>('atencion.creada').subscribe((data) => {
        const atencion = data?.atencion ?? data;
        const nombre = this.nombreCompleto(atencion?.paciente);

        this.mostrar(
          nombre ? `Nueva atención en espera: ${nombre}` : 'Se ha registrado una nueva atención.',
          ['notificacion-novamed', this.clasePrioridad(atencion?.prioridad)],
        );
      }),
    );

    return sub;
  }

  private nombreCompleto(p: any): string {
    return [p?.nombre, p?.apellido, p?.segundoApellido].filter(Boolean).join(' ');
  }

  private clasePrioridad(original: unknown): string {
    const texto =
      typeof original === 'object' && original !== null
        ? Object.values(
            (({ color, nombre, descripcion, nivel, valor }: any) => ({
              color,
              nombre,
              descripcion,
              nivel,
              valor,
            }))(original),
          )
            .filter(Boolean)
            .join(' ')
        : String(original ?? '');

    const p = texto
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();

    if (p.includes('rojo') || p.includes('critico')) return 'notificacion-emergencia-roja';
    if (p.includes('naranja') || p.includes('urgente')) return 'notificacion-emergencia-naranja';
    if (p.includes('amarillo') || p.includes('moderado')) return 'notificacion-emergencia-amarilla';
    if (p.includes('verde') || p.includes('leve')) return 'notificacion-emergencia-verde';
    return 'notificacion-emergencia-azul';
  }

  private mostrar(mensaje: string, panelClass: string[]): void {
    this.snackBar.open(mensaje, 'Cerrar', {
      duration: 8000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass,
    });
  }
}
